import { getPrimaryColor } from '@/utils/theme';
// 为避免重复new 对象节省内存 这边记录上次new过的实例  如果实例存在 则返回旧的实例
let model;
let cfg;

const PLAN_INFO_TYPE = Object.freeze({
    DEVICE: '1',
    CARRIER: '2'
});

let iconArray = [{ icon: '&#xe641;' }, { icon: '&#xec4f' }, { icon: '&#xec6d' }, { icon: '&#xe67e' }];

const equiIcon = {
    sensor: { icon: '&#xe674' },
    gateway: { icon: '&#xec5d' },
    display: { icon: '&#xe927' },
    relay: { icon: '&#xec5e' },
    gas: { icon: '&#xe99e' },
    magnetism: { icon: '&#xe638' },
    0: { icon: '&#xe674' },
    1: { icon: '&#xec5d' },
    2: { icon: '&#xe927' },
    3: { icon: '&#xec5e' }
};
var Point = function(x, y) {
    this.x = x;
    this.y = y;
};

var Model = function(id) {
    var me = this;
    this.id = id;
    this.canvas = document.getElementById(me.id);
    this.ctx = me.canvas.getContext('2d');
    this.imgX = null;
    this.imgY = null;
    this.imgScale = null;
    this.scale = 1;
    this.img = null;
    this.data = null;
    this.handle = null;
    this.pos = null;
    this.move = false;
    this.down = false;
    this.drop = false;
    this.path = '';
    this.mousedown = null;
    this.mousemove = null;
    this.mouseup = null;
    this.view = null;
    this.plan_view = [];
    this.nameParam = null;
    this.statusParam = null;
    this.carrierTypeParam = null;
    this.color = null;
    this.activeIdx = null;
    this.wheelZoom = null;
    this.flashing = false;
    this.hasFitted = false;
    this.dotInfo = false;

    this.setPlanView = function(data) {
        me.plan_view = data;
    };

    this.setBackgroundImg = function(path) {
        me.path = path;
    };

    this.clear = function() {
        if (!!me.ctx && !!me.canvas) {
            me.ctx.clearRect(0, 0, me.canvas.width, me.canvas.height);
        }
        me.imgX = 0;
        me.imgY = 0;
        me.imgScale = 1;
        me.scale = 1;
        me.path = '';
        me.hasFitted = false;
    };

    this.draw = function(data, background) {
        me.setBackgroundImg(background);
        me.setData(data, true, true);
    };

    this.zoomIn = function(rate, pos) {
        //放大
        const oldScale = me.imgScale;
        me.imgScale = me.scale * (rate + 0.1);
        me.scale = me.imgScale;
        // 1) 把鼠标在 canvas 上的坐标，映射到图片空间
        //    （x - imgX）/ oldScale 就是图片上的“物理点”
        // 2) 缩放后，让这个点依然落在同一个屏幕坐标上：
        me.imgX = pos.x - (pos.x - me.imgX) * (me.imgScale / oldScale);
        me.imgY = pos.y - (pos.y - me.imgY) * (me.imgScale / oldScale);
        me.drawImg(this.nameParam, this.statusParam);
    };

    this.zoomOut = function(rate, pos) {
        //缩小
        const oldScale = me.imgScale;
        me.imgScale = me.scale / (rate + 0.1);
        me.scale = me.imgScale;
        // 1) 把鼠标在 canvas 上的坐标，映射到图片空间
        //    （x - imgX）/ oldScale 就是图片上的“物理点”
        // 2) 缩放后，让这个点依然落在同一个屏幕坐标上：
        me.imgX = pos.x - (pos.x - me.imgX) * (me.imgScale / oldScale);
        me.imgY = pos.y - (pos.y - me.imgY) * (me.imgScale / oldScale);
        me.drawImg(this.nameParam, this.statusParam);
    };
    this.setData = function(data, flag, isClone, param = {}) {
        //设置数据，如果flag == true,重新绘制canvas,isClone是否克隆data数据（默认否）
        /**
         * param可选值
         * nameParam 设备名称key
         * statusParam 设备状态key
         * carrierTypeParam 设备类型key
         * color ???
         */
        this.nameParam = param.nameParam || this.nameParam;
        this.statusParam = param.statusParam || this.nameParam;
        this.carrierTypeParam = param.carrierTypeParam || this.carrierTypeParam;
        this.color = param.color || this.color;
        this.activeIdx = param.active;

        me.data = [];
        if (isClone === true) {
            for (var i = 0; i < data.length; i++) {
                var obj = {};
                for (var key in data[i]) {
                    obj[key] = data[i][key];
                    obj.idx = i;
                }
                me.data.push(obj);
            }
        } else {
            me.data = data;
        }

        if (flag === true) {
            me.loadImg(param.nameParam, param.statusParam);
        }
    };

    this.getData = function() {
        return me.data;
    };

    this.refresh = function(flag) {
        //刷新，如果flag == true，刷新所有信息（包括坐标等）
        if (flag) {
            me.imgX = 0;
            me.imgY = 0;
            me.imgScale = 1;
            me.scale = 1;
            me.hasFitted = false;
        }
        me.loadImg();
    };

    this.loadImg = function(nameParam, statusParam) {
        me.imgX = me.imgX == null ? 0 : me.imgX;
        me.imgY = me.imgY == null ? 0 : me.imgY;
        me.imgScale = me.imgScale == null ? 1 : me.imgScale;
        if (!!me.path) {
            me.img = me.img == null ? new Image() : me.img;
            me.img.onload = function() {
                if (!me.hasFitted) {
                    // 1. 计算画布和图片的比例
                    const cw = me.canvas.width;
                    const ch = me.canvas.height;
                    const iw = me.img.width;
                    const ih = me.img.height;

                    // 如果想“完整显示”且整个图片都在画布内，用 Math.min
                    me.imgScale = Math.min(cw / iw, ch / ih);
                    me.scale = me.imgScale

                    // 如果想“铺满”整个画布（会有裁剪），用 Math.max
                    // me.imgScale = Math.max(cw / iw, ch / ih);

                    // 2. 可选：让图片居中
                    me.imgX = (cw - iw * me.imgScale) / 2;
                    me.imgY = (ch - ih * me.imgScale) / 2;
                    me.hasFitted = true;
                }
                // 3. 真正绘制
                me.drawImg(nameParam, statusParam);
            };
            me.img.src = me.path;
        } else {
            me.drawImg(nameParam, statusParam);
        }
    };

    this.drawImg = function(nameParam = 'carrierName', statusParam = 'abnormal') {
        me.ctx.clearRect(0, 0, me.canvas.width, me.canvas.height);
        if (!!me.img) {
            me.ctx.drawImage(me.img, 0, 0, me.img.width || '', me.img.height, me.imgX, me.imgY, me.img.width * me.imgScale, me.img.height * me.imgScale);
        }

        if (me.data.length != 0) {
            // console.log(me.data);
            label: for (var i = 0; i < me.data.length; i++) {
                var obj = me.data[i];
                // console.log('obj===', obj)

                if (me.handle != null) {
                    me.handle(obj, me);
                    continue label;
                }

                if (!!obj.icon) {
                    var icon = new Image();
                    icon.onload = function() {
                        me.drawIcon(icon, obj.xpos, obj.ypos);
                    };
                    icon.src = obj.icon;
                } else {
                    me.ctx.beginPath();

                    //新需求，判断是设备还是监测点，设备描点圆点，监测点描正方形
                    if (obj.type === PLAN_INFO_TYPE.DEVICE) {
                        let computedType = ''
                        const flag1 = obj.obj?.deviceCatalog !== undefined && obj.obj?.deviceCatalog !== null
                        const flag2 = obj.obj?.deviceType !== undefined && obj.obj?.deviceType !== null
                        if (flag1 && flag2) {
                            const deviceType = obj.obj.deviceType
                            switch(obj.obj.deviceCatalog) {
                                case 0:
                                    const isOdd = obj.obj.deviceType % 2 !== 0
                                    if (isOdd) {
                                        computedType = 'T' + deviceType
                                    } else {
                                        computedType = 'H' + (deviceType - 1)
                                    }
                                    break
                                case 1:
                                    computedType = 'G'
                                    const gatewayType = deviceType - 1
                                    if (gatewayType !== 0) {
                                        computedType = computedType + gatewayType
                                    }
                                    break
                                case 2:
                                    computedType = 'D' + deviceType
                                    break
                                case 3:
                                    computedType = 'R' + deviceType
                                    break
                                case 5:
                                    computedType = 'G' + deviceType
                                    break
                                case 6:
                                    computedType = 'M' + deviceType
                                    break
                            }
                        }

                        if (obj.obj?.deviceCatalog === 0) {
                            // 构建数据，判断是否数据异常，status：0正常，1低温异常，2高温异常
                            const parts = [];
                            const { temp, hum } = obj.obj.probe
                                ? JSON.parse(obj.obj.probe)
                                : { temp: null, hum: null }; // 默认值
                            const rangeList = obj.obj.rangeList || []
                            if (temp) {
                                const tempRange = rangeList.find(item => item.unitCode === 'temp')
                                temp.status = tempRange ? temp.val > tempRange.max ? 2 : temp.val < tempRange.min ? 1 : 0 : 0
                                parts.push({ text: `${temp.val}℃`, status: temp.status });
                            }
                            if (hum) {
                                const humRange = rangeList.find(item => item.unitCode === 'hum')
                                hum.status = humRange ? hum.val > humRange.max ? 2 : hum.val < humRange.min ? 1 : 0 : 0
                                parts.push({ text: `${hum.val}%RH`, status: hum.status });
                            }

                            // 判断异常类型，abnormal：0正常，1数据异常，2离线异常，3数据异常+离线异常
                            let abnormal = 0;
                            const deviceStatus = obj.obj.deviceStatus ?? 0; // 如果为 null 或 undefined 默认为 0
                            let hasNonZeroItem = false;
                            parts.forEach(item => {
                                if (item.status !== 0) {
                                    hasNonZeroItem = true;
                                }
                            });
                            if (deviceStatus !== 0 && !hasNonZeroItem) {
                                abnormal = 0;
                            } else if (deviceStatus !== 0 && hasNonZeroItem) {
                                abnormal = 1;
                            } else if (deviceStatus === 0 && !hasNonZeroItem) {
                                abnormal = 2;
                            } else if (deviceStatus === 0 && hasNonZeroItem) {
                                abnormal = 3;
                            }

                            // 绘制背景矩形+左侧圆形+右侧文本+文本右侧三角形
                            me.drawDeviceOval(
                                obj.xpos,
                                obj.ypos,
                                this.activeIdx !== undefined && obj.idx === this.activeIdx ? '#f59a23' : null,
                                computedType,
                                parts,
                                abnormal
                            )
                        } else if (obj.obj?.deviceCatalog === 1) {
                            const abnormal = obj.obj.deviceStatus ?? 0 ? 0 : 2;
                            me.drawCarrierRect(
                                obj.xpos, obj.ypos,
                                this.activeIdx !== undefined && obj.idx === this.activeIdx ? '#f59a23'  : null,
                                computedType,
                                abnormal
                            )
                        } else {
                            const abnormal = obj.obj.deviceStatus ?? 0 ?  0 : 2;
                            me.drawCarrierCircle(
                                obj.xpos,
                                obj.ypos,
                                this.activeIdx !== undefined && obj.idx === this.activeIdx ? '#f59a23' : null,
                                computedType,
                                abnormal
                            )
                        }

                    } else {

                        // 偏移量
                        const pixelOffsetX = 20;
                        const pixelOffsetY = 0;
                        // 转换为数据坐标
                        const dataOffsetX = pixelOffsetX / me.imgScale;
                        const dataOffsetY = pixelOffsetY / me.imgScale;

                        me.drawCarrierRect(
                            obj.xpos,
                            obj.ypos,
                            this.activeIdx !== undefined && obj.idx === this.activeIdx ? '#f59a23'  : null,
                            null,
                            0
                        )
                        me.drawTextDef(obj.title, obj.xpos + dataOffsetX, obj.ypos + dataOffsetY);
                    }

                    me.ctx.fill();
                    me.ctx.lineWidth = 1;
                    me.ctx.stroke();
                    me.ctx.closePath();
                }
                me.ctx.beginPath();
                // 先把原来的颜色保存下来
                const copyColor = this.color;

                // 监测点文案
                if (this.activeIdx !== undefined && obj.idx !== this.activeIdx) {
                    this.color = undefined;
                    // 不需要在旁边标出名称了
                    me.drawText('', '', obj.xpos, obj.ypos - 10, 0);
                } else {
                    this.color = copyColor;
                    me.drawText('', '', obj.xpos, obj.ypos - 10, 0);
                }
                this.color = copyColor;

                // me.plan_view.forEach(function(v, i) {
                //     var val = '';
                //     var unit = '';
                //     if (typeof v.unit != 'undefined' && v.unit != null) {
                //         unit = obj[v.unit];
                //     }
                //     if (typeof obj[v.key] != 'undefined' && obj[v.key] != null) {
                //         val = obj[v.key];
                //         me.drawText(val, unit, obj.xpos, obj.ypos, ++i, '');
                //     }
                // });

                me.ctx.closePath();

                if (me.hoverData) {
                    const { xpos, ypos, title, id } = me.hoverData;
                    // canvas 上的实际像素坐标
                    const cx = me.imgX + xpos * me.imgScale;
                    const cy = me.imgY + ypos * me.imgScale;
                    const padding = 6;
                    const lineHeight = 16;
                    const lines = [`${title}`, `ID: ${id}`];

                    // 先测量文字最大宽度
                    let textW = 0;
                    me.ctx.font = '12px sans-serif';
                    lines.forEach(line => {
                        const w = me.ctx.measureText(line).width;
                        if (w > textW) textW = w;
                    });

                    const boxW = textW + padding * 2;
                    const boxH = lines.length * lineHeight + padding * 2;
                    const boxX = cx + 10;
                    const boxY = cy - boxH - 10;

                    // 背景
                    me.ctx.fillStyle = 'rgba(0,0,0,0.6)';
                    me.ctx.fillRect(boxX, boxY, boxW, boxH);

                    // 边框（可选）
                    me.ctx.strokeStyle = '#333';
                    me.ctx.strokeRect(boxX, boxY, boxW, boxH);

                    // 文本
                    me.ctx.fillStyle = '#fff';
                    me.ctx.textBaseline = 'top';
                    lines.forEach((line, i) => {
                        me.ctx.fillText(
                            line,
                            boxX + padding,
                            boxY + padding + i * lineHeight
                        );
                    });
                }
            }
        }
    };

    this.drawIcon = function(img, xpos, ypos) {
        me.ctx.drawImage(img, xpos + me.imgX, ypos + me.imgY, img.width * me.imgScale, img.height * me.imgScale);
    };
    // brian添加绘制iconfont图标作为锚点  date:2022 05 27
    this.drawIconfont = function(status, xpos, ypos, i, type = 1) {
        if (status == 0 || status === false) {
            // 主题色  0否
            me.ctx.fillStyle = '#344962';
        } else {
            // 红色  1是
            me.ctx.fillStyle = '#af0202';
        }
        me.ctx.font = '24px iconfont';
        // 类型是数字的话 走的是监测点   否则走的是设备
        if (typeof type === 'number')
            me.ctx.fillText(eval(('("' + iconArray[type - 1].icon).replace('&#x', '\\u').replace(';', '') + '")'), me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale);
        else {
            me.ctx.fillText(eval(('("' + equiIcon[type].icon).replace('&#x', '\\u').replace(';', '') + '")'), me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale);
        }
    };
    this.drawText = function(val, unit, xpos, ypos, index, type) {
        //设置字体样式
        me.ctx.font = 'bold 14px sans-serif';
        if (!!type) {
            me.ctx.fillStyle = this.color ? `${this.color}` : 'red';
        } else {
            //设置字体填充颜色
            me.ctx.fillStyle = this.color ? `${this.color}` : getPrimaryColor();
        }
        //从坐标点开始绘制文字
        me.ctx.fillText(val + unit, 30 + me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale + 5 + index * 14 * me.imgScale);
    };
    this.drawTextDef = function(val, xpos, ypos) {
        // 左对齐
        me.ctx.textAlign = 'start';
        //设置字体样式
        me.ctx.font = 'bold 14px sans-serif';
        //设置字体填充颜色
        me.ctx.fillStyle = this.color ? `${this.color}` : getPrimaryColor();
        //从坐标点开始绘制文字
        me.ctx.fillText(val, me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale);
    };

    this.drawDeviceIcon = function(px, py, type) {
        switch (type) {
            case 0: //正方形
                me.ctx.rect(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 15, 15);
                return;
            case 1: //圆点
                me.ctx.arc(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 8, 0, Math.PI * 2, true);
                return;
            case 2: //菱形
                me.createPolygonPath(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 10, 4, 0);
                return;
        }
        me.ctx.arc(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 8 * me.imgScale, 0, Math.PI * 2, true);
    };

    // 新需求，监测点描点时显示正方形就行
    this.drawCarrierRect = function(px, py, color, letter, abnormal) {
        const size = 24; // 正方形边长
        const x = me.imgX + px * me.imgScale - size / 2; // 左上角x
        const y = me.imgY + py * me.imgScale - size / 2; // 左上角y

        const currColor = this.calculateColor(abnormal, color)

        me.ctx.fillStyle = currColor;
        me.ctx.strokeStyle = currColor;

        me.ctx.rect(x, y, size, size);
        me.ctx.fill(); // 填充颜色
        me.ctx.beginPath();        // 开始路径，防止污染

        // 在中心画字母
        if (letter) {
            const centerX = x + size / 2;
            const centerY = y + size / 2;
            me.ctx.fillStyle = '#fff';              // 文本颜色，这里用黑色
            me.ctx.strokeStyle = '#fff';
            me.ctx.font = `${12}px sans-serif`;  // 字号略大于半径
            me.ctx.textAlign = 'center';            // 水平居中
            me.ctx.textBaseline = 'middle';         // 垂直居中
            me.ctx.fillText(letter, centerX, centerY);
        }
    };
    this.drawCarrierCircle = function(px, py, color, letter, abnormal) {
        const radius = 12;
        const x = me.imgX + px * me.imgScale;
        const y = me.imgY + py * me.imgScale;

        const currColor = this.calculateColor(abnormal, color)

        // 1. 画圆
        me.ctx.fillStyle = currColor;
        me.ctx.strokeStyle = currColor;
        me.ctx.arc(x, y, radius, 0, Math.PI * 2);
        me.ctx.fill();
        me.ctx.stroke();
        me.ctx.beginPath();

        // 2. 在圆心画字母
        if (letter) {
            // 文本样式：你可以根据 radius 动态计算
            me.ctx.fillStyle = '#fff';              // 文本颜色，这里用白色
            me.ctx.strokeStyle = '#fff';
            me.ctx.font = `${12}px sans-serif`;  // 字号略大于半径
            me.ctx.textAlign = 'center';            // 水平居中
            me.ctx.textBaseline = 'middle';         // 垂直居中
            me.ctx.fillText(letter, x, y);
        }
    };
    this.drawDeviceOval1 = function(px, py, color, letter, text, abnormal) {
        const ctx = me.ctx;
        const cx = me.imgX + px * me.imgScale;
        const cy = me.imgY + py * me.imgScale;

        // 样式参数
        const paddingY     = 0;              // 上下内边距
        const textPadding  = text ? 8 : 0;              // 文字左边距
        const fontSize     = 12;             // 字体大小
        ctx.font           = `${fontSize}px sans-serif`;
        const textWidth    = ctx.measureText(text).width;

        // 圆形和矩形大小
        const circleRadius = fontSize;                   // 圆的半径
        const gap          = text ? 6 : 0;                          // 圆形和文字之间的最小间距
        const rectRadius   = circleRadius;               // 圆角半径
        // 重新计算总宽度：圆形直径 + gap + textPadding + 文本宽度 + paddingY ×2
        const totalWidth   = circleRadius * 2 + gap + textPadding + textWidth + paddingY * 2;
        const totalHeight  = circleRadius * 2 + paddingY * 2;

        // 矩形左上角坐标
        const rectX = cx - totalWidth / 2;
        const rectY = cy - totalHeight / 2;

        // 1. 画圆角矩形
        ctx.beginPath();
        ctx.fillStyle = color;
        // 四角半径均为 circleRadius
        ctx.moveTo(rectX + rectRadius, rectY);
        ctx.lineTo(rectX + totalWidth - rectRadius, rectY);
        ctx.quadraticCurveTo(rectX + totalWidth, rectY, rectX + totalWidth, rectY + rectRadius);
        ctx.lineTo(rectX + totalWidth, rectY + totalHeight - rectRadius);
        ctx.quadraticCurveTo(rectX + totalWidth, rectY + totalHeight, rectX + totalWidth - rectRadius, rectY + totalHeight);
        ctx.lineTo(rectX + rectRadius, rectY + totalHeight);
        ctx.quadraticCurveTo(rectX, rectY + totalHeight, rectX, rectY + totalHeight - rectRadius);
        ctx.lineTo(rectX, rectY + rectRadius);
        ctx.quadraticCurveTo(rectX, rectY, rectX + rectRadius, rectY);
        ctx.closePath();
        ctx.fill();

        // 2. 画左侧圆形
        ctx.beginPath();
        ctx.fillStyle = 'green';
        const circleX = rectX + circleRadius;
        const circleY = cy;
        ctx.arc(circleX, circleY, circleRadius, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();

        // 3. 圆心字母
        if (letter) {
            ctx.fillStyle    = '#fff';
            ctx.textAlign    = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(letter, circleX, circleY);
        }

        // 4. 矩形内文字（加上 textPadding）
        const textX = circleX + circleRadius + gap;
        ctx.fillStyle    = '#000';
        ctx.textAlign    = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, textX, cy);
    };

    this.drawDeviceOval2 = function(px, py, extraColor, letter, text, abnormal) {
        const ctx = me.ctx;
        const cx = me.imgX + px * me.imgScale;
        const cy = me.imgY + py * me.imgScale;

        let circleColor;

        // —— 0. abnormal===0：不闪烁，固定展示 green 或 extraColor ——
        if (abnormal === 0) {
            circleColor = extraColor || 'green';
        } else {
            // 重绘时间
            const BLINK_PERIOD = extraColor ? 1500 : 1000; // 总周期 1000ms
            // —— 1. 根据 abnormal 拿到基础两色阵列 ——
            const BASE_COLOR_SETS = {
                1: ['red', 'green'],
                2: ['yellow', 'green'],
                3: ['red', 'yellow']
            };
            const baseColors = BASE_COLOR_SETS[abnormal] || ['green'];

            // —— 2. 如果 extraColor 有值，就加到 colors 里 ——
            const colors = extraColor
                ? baseColors.concat(extraColor)
                : baseColors;

            // —— 3. 计算当前 phase 索引 ——
            const phaseCount = colors.length;
            const phase = Math.floor(
                (Date.now() % BLINK_PERIOD) / (BLINK_PERIOD / phaseCount)
            );
            circleColor = colors[phase];
        }

        // 2. 文字和尺寸计算（和你原来一样）
        const paddingY     = 0;
        const textPadding  = text ? 8 : 0;
        const fontSize     = 12;
        ctx.font           = `${fontSize}px sans-serif`;
        const textWidth    = ctx.measureText(text).width;
        const circleRadius = fontSize;
        const gap          = text ? 6 : 0;
        const rectRadius   = circleRadius + 1;
        const totalWidth   = circleRadius * 2 + gap + textPadding + textWidth + paddingY * 2;
        const totalHeight  = circleRadius * 2 + paddingY * 2;
        const circleX = cx;
        const circleY = cy;
        const rectX = circleX - circleRadius;
        const rectY = circleY - totalHeight / 2;

        // 3. 画圆角矩形背景
        ctx.beginPath();
        ctx.fillStyle = '#95f204';
        // 四角画法（圆角半径 = circleRadius）
        ctx.moveTo(rectX + rectRadius, rectY);
        ctx.lineTo(rectX + totalWidth - rectRadius, rectY);
        ctx.quadraticCurveTo(rectX + totalWidth, rectY, rectX + totalWidth, rectY + rectRadius);
        ctx.lineTo(rectX + totalWidth, rectY + totalHeight - rectRadius);
        ctx.quadraticCurveTo(rectX + totalWidth, rectY + totalHeight, rectX + totalWidth - rectRadius, rectY + totalHeight);
        ctx.lineTo(rectX + rectRadius, rectY + totalHeight);
        ctx.quadraticCurveTo(rectX, rectY + totalHeight, rectX, rectY + totalHeight - rectRadius);
        ctx.lineTo(rectX, rectY + rectRadius);
        ctx.quadraticCurveTo(rectX, rectY, rectX + rectRadius, rectY);
        ctx.closePath();
        ctx.fill();

        // 4. 画左侧闪烁圆形
        ctx.beginPath();
        ctx.fillStyle = circleColor;
        ctx.arc(circleX, circleY, circleRadius, 0, Math.PI * 2);
        ctx.fill();
        ctx.beginPath();

        // 5. 圆心字母
        if (letter) {
            ctx.fillStyle    = '#fff';
            ctx.textAlign    = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(letter, circleX, circleY);
        }

        // 6. 矩形内文字
        const textX = circleX + circleRadius + gap;
        ctx.fillStyle    = '#000';
        ctx.textAlign    = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, textX, cy);
    };

    this.drawDeviceOval3 = function(px, py, extraColor, letter, data, abnormal) {
        const { temp, hum } = data;
        const ctx = me.ctx;
        const cx = me.imgX + px * me.imgScale;
        const cy = me.imgY + py * me.imgScale;

        // === 1. 计算圆与背景色（不变） ===
        let circleColor;
        if (abnormal === 0) {
            circleColor = extraColor || 'green';
        } else {
            // 重绘时间
            const BLINK_PERIOD = extraColor ? 1500 : 1000; // 总周期 1000ms
            // —— 1. 根据 abnormal 拿到基础两色阵列 ——
            const BASE_COLOR_SETS = {
                1: ['red', 'green'],
                2: ['yellow', 'green'],
                3: ['red', 'yellow']
            };
            const baseColors = BASE_COLOR_SETS[abnormal] || ['green'];

            // —— 2. 如果 extraColor 有值，就加到 colors 里 ——
            const colors = extraColor
                ? baseColors.concat(extraColor)
                : baseColors;

            // —— 3. 计算当前 phase 索引 ——
            const phaseCount = colors.length;
            const phase = Math.floor(
                (Date.now() % BLINK_PERIOD) / (BLINK_PERIOD / phaseCount)
            );
            circleColor = colors[phase];
        }

        // === 2. 文字段落准备 ===
        // 每一段：{ text: '...', color: '...', width: number }
        const segments = [];
        // helper: 根据 status 返回颜色
        const pickColor = status => {
            if (status === 0) return 'black';
            if (status === 1) return 'blue';
            if (status === 2) return 'yellow';
            return 'black';
        };

        // 构造 segments 数组
        if (temp) {
            const tTxt = `${temp.val}℃`;
            ctx.font = `12px sans-serif`;
            const w = ctx.measureText(tTxt).width;
            segments.push({ text: tTxt, color: pickColor(temp.status), width: w });
        }
        if (temp && hum) {
            // 加一个斜杠，固定用黑色
            const slash = '/';
            const w = ctx.measureText(slash).width;
            segments.push({ text: slash, color: 'black', width: w });
        }
        if (hum) {
            const hTxt = `${hum.val}%RH`;
            ctx.font = `12px sans-serif`;
            const w = ctx.measureText(hTxt).width;
            segments.push({ text: hTxt, color: pickColor(hum.status), width: w });
        }

        // === 3. 测量总体尺寸，并画背景 ===
        const fontSize = 12;
        const paddingY = 0;
        const textPadding = segments.length ? 8 : 0;
        const circleRadius = fontSize;
        const gap = segments.length ? 6 : 0;
        const rectRadius = circleRadius + 1;

        const textWidth = segments.reduce((sum, s) => sum + s.width, 0);
        const totalWidth = circleRadius * 2 + gap + textPadding + textWidth + paddingY * 2;
        const totalHeight = circleRadius * 2 + paddingY * 2;
        const rectX = cx - circleRadius;
        const rectY = cy - totalHeight / 2;

        // 背景
        ctx.beginPath();
        ctx.fillStyle = '#95f204';
        ctx.moveTo(rectX + rectRadius, rectY);
        ctx.lineTo(rectX + totalWidth - rectRadius, rectY);
        ctx.quadraticCurveTo(rectX + totalWidth, rectY, rectX + totalWidth, rectY + rectRadius);
        ctx.lineTo(rectX + totalWidth, rectY + totalHeight - rectRadius);
        ctx.quadraticCurveTo(rectX + totalWidth, rectY + totalHeight, rectX + totalWidth - rectRadius, rectY + totalHeight);
        ctx.lineTo(rectX + rectRadius, rectY + totalHeight);
        ctx.quadraticCurveTo(rectX, rectY + totalHeight, rectX, rectY + totalHeight - rectRadius);
        ctx.lineTo(rectX, rectY + rectRadius);
        ctx.quadraticCurveTo(rectX, rectY, rectX + rectRadius, rectY);
        ctx.closePath();
        ctx.fill();

        // === 4. 画左侧圆圈 ===
        ctx.beginPath();
        ctx.fillStyle = circleColor;
        ctx.arc(cx, cy, circleRadius, 0, Math.PI * 2);
        ctx.fill();

        // 文字中心字母保持不变
        if (letter) {
            ctx.fillStyle = '#fff';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(letter, cx, cy);
        }

        // === 5. 画分段文字 ===
        let x = cx + circleRadius + gap;           // 第一个字符的起始 X
        ctx.textBaseline = 'middle';
        ctx.font = `${fontSize}px sans-serif`;
        segments.forEach(seg => {
            ctx.fillStyle = seg.color;
            ctx.textAlign = 'left';
            ctx.fillText(seg.text, x, cy);
            x += seg.width;
        });
    };

    /*
     * drawDeviceOval：支持文字、状态三角及闪烁效果
     * @param px, py: 设备坐标
     * @param extraColor: 高亮圆圈颜色
     * @param letter: 圆圈内字母
     * @param parts: 数组，{ text: 显示文本, status: 0-无标记、1-蓝色倒三角、2-黄色正三角 }
     */
    this.drawDeviceOval = function(px, py, extraColor, letter, parts, abnormal) {
        const ctx = me.ctx
        const cx = me.imgX + px * me.imgScale
        const cy = me.imgY + py * me.imgScale

        // 文字配置
        const fontSize = 12
        ctx.font = `${fontSize}px sans-serif`
        ctx.textBaseline = 'middle'
        ctx.textAlign = 'left'

        // 三角尺寸（底边加长）
        const triBase = 15    // 三角底边长度
        const triHeight = 10   // 三角高度

        // 计算各部分宽度
        const slashWidth = ctx.measureText('/').width
        const textWidths = parts.map(p => ctx.measureText(p.text).width)
        const markerWidths = parts.map(p => (p.status > 0 ? triBase + 14 : 12))
        const additionalWidth = parts.length === 1 ? 9 : 0

        // 总宽：文字 + 标记 + 斜杠 + 内边距
        const padding = 6
        const gap = 4 // 文本与标记间距
        const totalText = textWidths.reduce((a, b) => a + b, 0)
        const totalMarker = markerWidths.reduce((a, b) => a + b, 0)
        const totalSlash = slashWidth * (parts.length - 1)
        const insideW = totalText + totalMarker + totalSlash + padding * 2 + gap * (parts.length) + additionalWidth
        const insideH = fontSize + padding * 2

        const circleR = fontSize
        const circleX = cx
        const circleY = cy

        // 背景矩形
        if (me.dotInfo && parts.length !== 0) {
            const rectX = circleX - circleR
            const rectY = circleY - insideH / 2
            const rectR = fontSize + 1
            ctx.fillStyle = '#95f204'
            ctx.beginPath()
            ctx.moveTo(rectX + rectR, rectY)
            ctx.lineTo(rectX + insideW - rectR, rectY)
            ctx.quadraticCurveTo(rectX + insideW, rectY, rectX + insideW, rectY + rectR)
            ctx.lineTo(rectX + insideW, rectY + insideH - rectR)
            ctx.quadraticCurveTo(rectX + insideW, rectY + insideH, rectX + insideW - rectR, rectY + insideH)
            ctx.lineTo(rectX + rectR, rectY + insideH)
            ctx.quadraticCurveTo(rectX, rectY + insideH, rectX, rectY + insideH - rectR)
            ctx.lineTo(rectX, rectY + rectR)
            ctx.quadraticCurveTo(rectX, rectY, rectX + rectR, rectY)
            ctx.closePath()
            ctx.fill()
        }

        // 左侧圆圈及闪烁逻辑
        const circleColor = this.calculateColor(abnormal, extraColor)

        // 左侧圆圈
        ctx.fillStyle = circleColor
        ctx.beginPath()
        ctx.arc(circleX, circleY, circleR, 0, 2 * Math.PI)
        ctx.fill()
        if (letter) {
            ctx.fillStyle = '#fff'
            ctx.textAlign = 'center'
            ctx.fillText(letter, circleX, circleY)
        }
        ctx.beginPath();



        // 绘制文字、三角标志和斜杠
        if (me.dotInfo) {
            let x = circleX + circleR + gap
            ctx.textAlign = 'left'
            parts.forEach((p, i) => {
                // 文本
                ctx.fillStyle = '#000'
                ctx.fillText(p.text, x, cy)
                ctx.beginPath()
                x += textWidths[i]

                // 三角
                if (p.status > 0) {
                    const tx = x + 2
                    const ty = cy
                    ctx.fillStyle = p.status === 1 ? '#02a7f0' : '#f59a23'
                    if (p.status === 1) {
                        // 倒三角
                        ctx.moveTo(tx, ty - triHeight / 2)
                        ctx.lineTo(tx + triBase / 2, ty + triHeight / 2)
                        ctx.lineTo(tx + triBase, ty - triHeight / 2)
                    } else {
                        // 正三角
                        ctx.moveTo(tx, ty + triHeight / 2)
                        ctx.lineTo(tx + triBase / 2, ty - triHeight / 2)
                        ctx.lineTo(tx + triBase, ty + triHeight / 2)
                    }
                    ctx.closePath()
                    ctx.fill()
                    ctx.beginPath();
                    x += triBase + 4
                }

                // 斜杠
                if (i < parts.length - 1) {
                    ctx.fillStyle = '#000'
                    ctx.fillText('/', x, cy)
                    ctx.beginPath();
                    x += slashWidth + 4
                }
            })
        }
    }

    this.calculateColor = function(abnormal, extraColor) {
        // —— 0. abnormal===0：不闪烁，固定展示 green 或 extraColor ——
        let resultColor = ''
        if (this.flashing || abnormal === 0) {
            resultColor = extraColor || 'green';
        } else {
            // 重绘时间
            const BLINK_PERIOD = extraColor ? 1500 : 1000; // 总周期 1000ms
            // —— 1. 根据 abnormal 拿到基础两色阵列 ——
            const BASE_COLOR_SETS = {
                1: ['#cbcb00', 'green'],
                2: ['red', 'green'],
                3: ['red', '#cbcb00']
            };
            const baseColors = BASE_COLOR_SETS[abnormal] || ['green'];

            // —— 2. 如果 extraColor 有值，就加到 colors 里 ——
            const colors = extraColor
                ? baseColors.concat(extraColor)
                : baseColors;

            // —— 3. 计算当前 phase 索引 ——
            const phaseCount = colors.length;
            const phase = Math.floor(
                (Date.now() % BLINK_PERIOD) / (BLINK_PERIOD / phaseCount)
            );
            resultColor = colors[phase];
        }
        return resultColor
    }


    this.getPolygonPoints = function(centerX, centerY, radius, sides, startAngle) {
        var points = [],
            angle = startAngle || 0;
        for (var i = 0; i < sides; ++i) {
            points.push(new Point(centerX + radius * Math.sin(angle), centerY - radius * Math.cos(angle)));
            angle += (2 * Math.PI) / sides;
        }
        return points;
    };

    this.createPolygonPath = function(centerX, centerY, radius, sides, startAngle) {
        var me = this;
        var points = this.getPolygonPoints(centerX, centerY, radius, sides, startAngle);
        me.ctx.beginPath();
        me.ctx.moveTo(points[0].x, points[0].y);
        for (var i = 1; i < sides; ++i) {
            me.ctx.lineTo(points[i].x, points[i].y);
        }
        me.ctx.closePath();
    };

    this.windowToCanvas = function(canvas, x, y) {
        var box = canvas.getBoundingClientRect();
        return {
            x: x - box.left - (box.width - canvas.width) / 2,
            y: y - box.top - (box.height - canvas.height) / 2
        };
    };

    this.moveCanvas = function(event) {
        me.drop = true;
        me.canvas.style.cursor = 'move';
        var currentPos = me.windowToCanvas(me.canvas, event.pageX, event.pageY);
        var x = currentPos.x - me.pos.x;
        var y = currentPos.y - me.pos.y;
        me.pos = currentPos;
        me.imgX += x;
        me.imgY += y;
        me.drawImg(this.nameParam, this.statusParam, this.color);
    };

    this.calculateTarget = function(pos) {
        // 先算出像素坐标反算的数据坐标
        const dataX = (pos.x - me.imgX) / me.imgScale;
        const dataY = (pos.y - me.imgY) / me.imgScale;

        // 找到第一个命中点，用 24px 半径来检测
        const pixelRadius = 20;

        // 找到第一个距离 < radius 的点
        const hit = me.data.find(item => {
            const dx = item.xpos - dataX;
            const dy = item.ypos - dataY;
            return Math.hypot(dx, dy) * me.imgScale < pixelRadius;
        })

        if (!hit) {
            return null
        }

        // 计算“显示用”的像素坐标
        const screenX = me.imgX + hit.xpos * me.imgScale;
        const screenY = me.imgY + hit.ypos * me.imgScale;

        return {
            data: hit,
            pos: {
                x: screenX,
                y: screenY
            }
        }
    }

    this.eventInit = function() {
        const canvas = me.canvas;

        // —— 1. 禁用浏览器默认菜单 ——
        canvas.addEventListener('contextmenu', e => {
            e.preventDefault();
        });

        // —— 2. mousedown ——
        function onMouseDown(e) {
            if (!me.img) return;
            // 只对左键中键拖：e.button===0/1
            if (e.button !== 0 && e.button !== 1) return;
            me.down = true;
            me.pos = me.windowToCanvas(canvas, e.pageX, e.pageY);
            const target = me.calculateTarget(me.pos)
            me.mousedown && me.mousedown(me.down, me.drop, me.data, me.pos, target, e);
        }

        function onMouseMove(e) {
            const pos = me.windowToCanvas(canvas, e.pageX, e.pageY);
            const target = me.calculateTarget(pos)
            me.canvas.style.cursor = target ? 'pointer' : 'default';
            me.mousemove && me.mousemove(me.down, me.drop, me.data, pos, target, e);
            if (me.down && me.move) {
                me.moveCanvas(e);
            }
        }

        function onMouseUp(e) {
            me.canvas.style.cursor = 'default';
            me.pos = me.windowToCanvas(canvas, e.pageX, e.pageY);
            const x = (me.pos.x - me.imgX) / me.imgScale;
            const y = (me.pos.y - me.imgY) / me.imgScale;
            const target = me.calculateTarget(me.pos)
            me.mouseup && me.mouseup(me.img, me.down, me.drop, me.data, x, y, me.pos, target, e);
            me.down = false;
            me.drop = false;
        }

        function onWheelZoom(e) {
            // 阻止页面滚动
            // e.preventDefault();
            // deltaY > 0 是向下滚，deltaY < 0 向上滚
            const rate = Math.abs(e.deltaY) / 100;  // 根据滚速转换缩放比例
            const pos = me.windowToCanvas(canvas, e.pageX, e.pageY);
            if (e.deltaY < 0) {
                me.zoomIn(rate, pos);
            } else {
                me.zoomOut(rate, pos);
            }
        }

        // 绑定
        canvas.addEventListener('mousedown', onMouseDown);
        canvas.addEventListener('mousemove', onMouseMove);
        canvas.addEventListener('mouseup',   onMouseUp);
        if (me.wheelZoom) canvas.addEventListener('wheel',   onWheelZoom);

    };
};

// 按理说不应该这么写 在全局不可能只有一个实例
function getInstance(config) {
    let model = new Model(config.id);
    if (typeof config.handle == 'function') {
        model.handle = config.handle;
    }
    model.move = Boolean(config.move);
    model.wheelZoom = Boolean(config.wheelZoom);
    model.dotInfo = Boolean(config.dotInfo);
    // 只在传了回调时覆盖
    if (typeof config.mouseup === 'function') {
        model.mouseup = config.mouseup;
    }
    if (typeof config.mousedown === 'function') {
        model.mousedown = config.mousedown;
    }
    if (typeof config.mousemove === 'function') {
        model.mousemove = config.mousemove;
    }
    model.eventInit();
    return model;
}

const handlePlanData = (data, type) => {
    if (type === PLAN_INFO_TYPE.DEVICE) {
        return {
            type: type,
            id: data.deviceId + '-' + data.deviceCatalog,
            title: data.deviceCode,
            xpos: data.xpos,
            ypos: data.ypos,
            obj: data
        }
    } else {
        return {
            type: type,
            id: data.carrierId,
            title: data.carrierName,
            xpos: data.xpos,
            ypos: data.ypos,
            obj: data
        }
    }
}

export { getInstance, Model, handlePlanData, PLAN_INFO_TYPE };
